import React from "react";

import classNames from "classnames";

interface StatusTagProps {
  children: React.ReactNode;
}

function StatusTag({ children }: StatusTagProps): React.JSX.Element {
  const tagClassNames = classNames(
    "rounded border px-2 py-0.5 text-xs font-medium border-border bg-background text-muted-foreground",
  );
  return <div className={tagClassNames}>{children}</div>;
}

export default StatusTag;
